export enum PartTransactionTypes {
    // Grid
    GET_DATE_WISE_PART_TRANSACTION_LIST = "@@part_transaction/GET_DATE_WISE_PART_TRANSACTION_LIST",
    GET_DATE_WISE_PART_TRANSACTION_LIST_SUCCESS = "@@part_transaction/GET_DATE_WISE_PART_TRANSACTION_LIST_SUCCESS",
    GET_DATE_WISE_PART_TRANSACTION_LIST_FAIL = "@@part_transaction/GET_DATE_WISE_PART_TRANSACTION_LIST_FAIL",

}